import WebBaseModal from './base-modal'

export default WebBaseModal
